import * as angular from "angular";
import { ElectionDataProvider } from "../../data-provider/election.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Field } from "../../models/field.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ExportDataProvider } from "../../data-provider/export.dp";
import { Effort } from "../../models/effort.model";

let ExportDialogComponent = {
    selector: "vcExportDialog",
    templateUrl: "/angular/components/export/export-dialog.component.html",
    bindings: {
        importDataType: "=",
    },
    controller: class ExportDialogController {
        public importDataType: string;

        private readonly __env: any;
        private readonly voterChoices: {
            name: string;
            checked: true | false;
            choices: any[];
        };
        private readonly houseChoices = {
            name: "House",
            checked: true,
            choices: [],
        };
        private readonly canvassChoices = {
            name: "Interaction",
            checked: true,
            choices: [],
        };
        private dialog: DialogUtils;
        private dataProvider: ExportDataProvider;
        private fieldDataProvider: FieldDataProvider;
        private electionDataProvider: ElectionDataProvider;
        private effortDataProvider: EffortDataProvider;

        public exportChoices: object;
        public loading: boolean = true;
        public permissionProvider: PermissionCheck;
        public navigationBarService: NavigationBarHelperService;
        public isLeaderView: boolean;
        public selectedEffort: any = null;
        public hasMultipleEfforts: boolean = false;

        constructor(
            __env: any,
            DialogUtils: DialogUtils,
            FieldDataProvider: FieldDataProvider,
            ExportDataProvider: ExportDataProvider,
            ElectionDataProvider: ElectionDataProvider,
            EffortDataProvider: EffortDataProvider,
            PermissionCheck: PermissionCheck,
            NavigationBarHelperService: NavigationBarHelperService,
            __app_type: string
        ) {
            this.__env = __env;
            this.dialog = DialogUtils;
            this.dataProvider = ExportDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.electionDataProvider = ElectionDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.permissionProvider = PermissionCheck;
            this.navigationBarService = NavigationBarHelperService;
            this.isLeaderView = __app_type == "LEADER";
            this.voterChoices = {
                name:
                    this.__env.strings.voter.charAt(0).toUpperCase() +
                    this.__env.strings.voter.slice(1),
                checked: false,
                choices: [],
            };
        }

        $onInit() {
            let showChecked = this.importDataType != "houses";

            this.voterChoices.checked = showChecked;
            this.canvassChoices.checked = showChecked;
            this.exportChoices = [
                this.voterChoices,
                this.houseChoices,
                this.canvassChoices,
                {
                    name: "Custom Field",
                    checked: showChecked,
                    choices: [],
                },
                {
                    name: "Election",
                    checked: showChecked,
                    choices: [],
                },
            ];

            this.dataProvider.all().then((exports: object[]) => {
                this.loading = false;
                angular.forEach(exports, (dataPoint: any) => {
                    if (dataPoint.expcgroup == "Voter") {
                        this.voterChoices.choices.push({
                            name: dataPoint.expcformattedname,
                            id: dataPoint.expcid,
                            checked: showChecked,
                            hokey: dataPoint.hokey,
                        });
                    } else if (dataPoint.expcgroup == "House") {
                        this.houseChoices.choices.push({
                            name: dataPoint.expcformattedname,
                            id: dataPoint.expcid,
                            checked: true,
                        });
                    } else if (dataPoint.expcgroup == "Canvass") {
                        this.canvassChoices.choices.push({
                            name: dataPoint.expcformattedname,
                            id: dataPoint.expcid,
                            checked: showChecked,
                        });
                    }
                });
                this.fieldDataProvider
                    .getAllFields()
                    .then((fields: Array<Field>) => {
                        this.matchChoiceNameWithFieldName(fields);
                    });
            });

            this.fieldDataProvider
                .getCustomFields()
                .then((customFields: Array<Field>) => {
                    let customFieldChoices = [];
                    if (customFields) {
                        for (let i = 0; i < customFields.length; i++) {
                            customFieldChoices.push({
                                name: customFields[i].name,
                                cfid: customFields[i].cfid,
                                checked: showChecked,
                            });
                        }
                    }
                    this.exportChoices[3].choices = customFieldChoices;
                });

            this.electionDataProvider
                .getAllElections()
                .then((elections: any[]) => {
                    let electionChoices = [];
                    for (let i = 0; i < elections.length; i++) {
                        electionChoices.push({
                            name: elections[i].elname,
                            elid: elections[i].elid,
                            checked: showChecked,
                        });
                    }
                    this.exportChoices[4].choices = electionChoices;
                });

            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.hasMultipleEfforts = efforts.length > 1;
                    if (this.hasMultipleEfforts) {
                        this.effortDataProvider
                            .getSelectedEffort()
                            .then((effort: Effort) => {
                                this.selectedEffort = effort;
                            });
                    }
                });
        }

        matchChoiceNameWithFieldName(fields: Array<Field>): void {
            const choicesWithHoKey = this.voterChoices.choices.filter(
                (choice: any) => choice.hokey
            );

            angular.forEach(choicesWithHoKey, (choice: any) => {
                choice.name =
                    this.fieldDataProvider.matchDynamicFieldName(
                        fields,
                        choice
                    ) || choice.name;
            });
        }

        selectAll(category: any): void {
            if (category.checked) {
                for (let i = 0; i < category.choices.length; i++) {
                    category.choices[i].checked = true;
                }
            } else {
                for (let i = 0; i < category.choices.length; i++) {
                    category.choices[i].checked = false;
                }
            }
        }

        categoryChoiceChange(categoryChoices: any, choice: any): void {
            if (choice.checked) {
                let allSelected = true;
                for (let i = 0; i < categoryChoices.choices.length; i++) {
                    if (!categoryChoices.choices[i].checked) {
                        allSelected = false;
                        break;
                    }
                }
                categoryChoices.checked = allSelected;
            } else {
                categoryChoices.checked = false;
            }
        }

        ok(): void {
            this.dialog.hide(this.exportChoices);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("export", [])
    .component(ExportDialogComponent.selector, ExportDialogComponent);
